import { deploymentIdentity } from "@pima/web-api/deployment";

declare const __SENTRY_RELEASE__: string;

// Vite binds this module to the executing bundle, independently of runtime config.
export const executingReleaseId = deploymentIdentity(__SENTRY_RELEASE__);
